export class RecordingPublishError extends Error {
	constructor(message: string) {
		super(message)
		this.name = 'RecordingPublishError'
	}
}

export const isRecordingPublishError = (
	error: unknown
): error is RecordingPublishError => error instanceof RecordingPublishError
